import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UserService } from "./user.service";
import { BaseEntityService } from "./rest-common.service";
import {
  DataCommission,
  SystemCommission,
  Transaction,
  adspCommission,
  bdspCommission,
  AdServiceFee,
  tdspCommission,
  Commission,
} from "src/app/models/user";
import { Observable } from "rxjs";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class AgencyService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/agency/`;

  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  addCredit(credit: Transaction, id) {
    let url = `${this.resource_url}${id}/credit/`;
    return this.post(url, credit);
  }

  addDebit(debit: Transaction, id) {
    let url = `${this.resource_url}${id}/debit/`;
    return this.post(url, debit);
  }

  getBalance(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/balance/`, "", params);
    return this.get(url);
  }

  getStripePaymentLimit(id, params = {}) {
  let url = this.buildUrl(`${this.resource_url}${id}/stripe-payment-limit/`, "", params);
  return this.get(url);
  }

  getAccountStatement(id, params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}${id}/account-statement/`,
      "",
      params
    );
    return this.get(url);
  }

  getInvoiceStatement(id, params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}${id}/account-invoice/`,
      "",
      params
    );
    return this.get(url);
  }

  getOfflineCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/vdsp-oc/`, "", params);
    return this.get(url);
  }

  setOfflineCommission(id, commission) {
    let url = `${this.resource_url}${id}/vdsp-oc/`;
    return this.put(url, commission);
  }

  getSystemCommission(id) {
    let url = `${this.resource_url}${id}/sc/`;
    return this.get(url);
  }

  getCommissionHistory(id) {
    let url = `${this.resource_url}${id}/commission-history/`;
    return this.get(url);
  }

  setSystemCommission(id, commission: SystemCommission) {
    let url = `${this.resource_url}${id}/sc/`;
    return this.put(url, commission);
  }

  getDataCommission(id) {
    let url = `${this.resource_url}${id}/dc/`;
    return this.get(url);
  }

  setDataCommission(id, commission: DataCommission) {
    let url = `${this.resource_url}${id}/dc/`;
    return this.put(url, commission);
  }

  getAdspSystemCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-sc/`, "", params);
    return this.get(url);
  }

  setAdspSystemCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-sc/`;
    return this.put(url, commission);
  }

  getAdspDataCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-dc/`, "", params);
    return this.get(url);
  }

  setAdspDataCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-dc/`;
    return this.put(url, commission);
  }

  getAdspContractCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-cc/`, "", params);
    return this.get(url);
  }

  setAdspContractCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-cc/`;
    return this.put(url, commission);
  }

  getPrivateDealCommission(id) {
    let url = `${this.resource_url}${id}/vdsp-cdc/`;
    return this.get(url);
  }

  setPrivateDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/vdsp-cdc/`;
    return this.put(url, commission);
  }

  getRegularDealCommission(id) {
    let url = `${this.resource_url}${id}/vdsp-sdc/`;
    return this.get(url);
  }

  setRegularDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/vdsp-sdc/`;
    return this.put(url, commission);
  }

  getAdspDealCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-dlc/`, "", params);
    return this.get(url);
  }

  setAdspDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-dlc/`;
    return this.put(url, commission);
  }

  getBdspContractCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-cc/`;
    return this.get(url);
  }

  setBdspContractCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-cc/`;
    return this.put(url, commission);
  }

  getBdspSystemCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-sc/`;
    return this.get(url);
  }

  setBdspSystemCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-sc/`;
    return this.put(url, commission);
  }

  getBdspDataCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-dc/`;
    return this.get(url);
  }

  setBdspDataCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-dc/`;
    return this.put(url, commission);
  }

  getBdspContractDealCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-cdc/`;
    return this.get(url);
  }

  setBdspContractDealCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-cdc/`;
    return this.put(url, commission);
  }

  getBdspSystemDealCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-sdc/`;
    return this.get(url);
  }

  setBdspSystemDealCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-sdc/`;
    return this.put(url, commission);
  }

  getBdspAgencyCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-agency-comm/`
    return this.get(url);
  }

  setBdspAgencyCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-agency-comm/`
    return this.put(url, commission);
  }

  getTdspContractCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-cc/`;
    return this.get(url);
  }

  setTdspContractCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-cc/`;
    return this.put(url, commission);
  }

  getTdspSystemCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-sc/`;
    return this.get(url);
  }

  setTdspSystemCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-sc/`;
    return this.put(url, commission);
  }

  getTdspDataCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-dc/`;
    return this.get(url);
  }

  setTdspDataCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-dc/`;
    return this.put(url, commission);
  }

  getTdspContractDealCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-cdc/`;
    return this.get(url);
  }

  setTdspContractDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-cdc/`;
    return this.put(url, commission);
  }

  getTdspSystemDealCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-sdc/`;
    return this.get(url);
  }

  setTdspSystemDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-sdc/`;
    return this.put(url, commission);
  }

  getTdspAgencyCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-agency-comm/`
    return this.get(url);
  }

  setTdspAgencyCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-agency-comm/`
    return this.put(url, commission);
  }

  uploadRegistrationForm(data, params = {}): Observable<any> {
    let url = `${this.BASE_API_URL}/file-records/upload/`;
    return this.post(url, data);
  }

  getAdServiceFee(id, type: string, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/${type}/`, "", params);
    return this.get(url);
  }
  setAdServiceFee(id, type: string, adServiceFee: AdServiceFee, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/${type}/`, "", params);
    return this.put(url, adServiceFee);
  }
  getTdspCpmCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-fixed-cpm/`
    return this.get(url);
  }

  setTdspCpmCommission(id, commission: tdspCommission, adType: string) {
    const url = `${this.resource_url}${id}/tdsp-fixed-cpm/`;
    return this.put(url, { ...commission, ad_type: adType });
  }

  getTdspCpcCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-fixed-cpc/`
    return this.get(url);
  }

  setTdspCpcCommission(id, commission: tdspCommission, adType: string) {
    let url = `${this.resource_url}${id}/tdsp-fixed-cpc/`
    return this.put(url, { ...commission, ad_type: adType });
  }

  getHyperlocalAgencyCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-agency-comm/`
    return this.get(url);
  }

  setHyperlocalAgencyCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/hyperlocal-agency-comm/`
    return this.put(url, commission);
  }

  getHyperlocalCpmCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-fixed-cpm/`
    return this.get(url);
  }

  setHyperlocalCpmCommission(id, commission: tdspCommission, adType: string) {
    const url = `${this.resource_url}${id}/hyperlocal-fixed-cpm/`;
    return this.put(url, { ...commission, ad_type: adType });
  }

  getHyperlocalCpcCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-fixed-cpc/`
    return this.get(url);
  }

  setHyperlocalCpcCommission(id, commission: tdspCommission, adType: string) {
    let url = `${this.resource_url}${id}/hyperlocal-fixed-cpc/`
    return this.put(url, { ...commission, ad_type: adType });
  }
  getHyperlocalContractCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-cc/`;
    return this.get(url);
  }

  setHyperlocalContractCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/hyperlocal-cc/`;
    return this.put(url, commission);
  }

  setHyperlocalSystemCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/hyperlocal-sc/`
    return this.put(url, commission);
  }

  getHyperlocalSystemCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-sc/`
    return this.get(url);
  }

  setHyperlocalDataCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/hyperlocal-dc/`
    return this.put(url, commission);
  }

  getHyperlocalDataCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-dc/`
    return this.get(url);
  }

  getHyperlocalContractDealCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-cdc/`
    return this.get(url);
  }

  setHyperlocalContractDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/hyperlocal-cdc/`
    return this.put(url, commission);
  }

  getHyperlocalSystemDealCommission(id) {
    let url = `${this.resource_url}${id}/hyperlocal-sdc/`
    return this.get(url);
  }

  setHyperlocalSystemDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/hyperlocal-sdc/`
    return this.put(url, commission);
  }

}

@Injectable({
  providedIn: "root",
})
export class AgencyUserService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/agency/users/`;

  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  associateAgencyUsers(id, agency_advertisers, params = {}) {
    let data = {
      agency_advertisers: agency_advertisers,
    };
    let url = this.buildUrl(`${this.resource_url}${id}/associate/`, "", params);
    return this.put(url, data);
  }

  updateLicense(data, params) {
    let url = this.buildUrl(`${this.resource_url}qlik-access/`, "", params);
    return this.put(url, data);
  }

  getUserClickAccess(params) {
    let url = this.buildUrl(`${this.resource_url}qlik-access/`, "", params);
    return this.get(url);
  }
}

@Injectable({
  providedIn: "root",
})
export class AgencyAdvertiserService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/agency-advertiser/`;

  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  getTdspAgencyCommission(agencyAdvId, params = {}) {
  const url = this.buildUrl(`${this.resource_url}${agencyAdvId}/tdsp-agc-com/`, "", params);
  return this.get(url);
}

 setTdspAgencyCommission(id, commission: tdspCommission, params = {}) {
  const url = this.buildUrl(`${this.resource_url}${id}/tdsp-agc-com/`, "", params);
  return this.put(url, commission);
}

  getTdspCpmCommission(id,params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/tdsp-fixed-cpm/`, "", params);
    return this.get(url);
  }

  setTdspCpmCommission(id, commission: tdspCommission, adType: string, params = {}) {
    const url = this.buildUrl(`${this.resource_url}${id}/tdsp-fixed-cpm/`, "", params);
    return this.put(url, { ...commission, ad_type: adType });
  }

  getTdspCpcCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/tdsp-fixed-cpc/`, "", params);
    return this.get(url);
  }

  setTdspCpcCommission(id, commission: tdspCommission, adType: string, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/tdsp-fixed-cpc/`, "", params);
    return this.put(url, { ...commission, ad_type: adType });
  }

  getHyperlocalAgencyCommission(id) {
    const url = `${this.resource_url}${id}/hyperlocal-agc-com/`;
    return this.get(url);
  }

  setHyperlocalAgencyCommission(id, commission: tdspCommission) {
    const url = `${this.resource_url}${id}/hyperlocal-agc-com/`;
    return this.put(url, commission);
  }

  getHyperlocalCpmCommission(id) {
    const url = `${this.resource_url}${id}/hyperlocal-fixed-cpm/`;
    return this.get(url);
  }

  setHyperlocalCpmCommission(id, commission: tdspCommission, adType: string) {
    const url = `${this.resource_url}${id}/hyperlocal-fixed-cpm/`;
    return this.put(url, { ...commission, ad_type: adType });
  }

  getHyperlocalCpcCommission(id) {
    const url = `${this.resource_url}${id}/hyperlocal-fixed-cpc/`;
    return this.get(url);
  }

  setHyperlocalCpcCommission(id, commission: tdspCommission, adType: string) {
    const url = `${this.resource_url}${id}/hyperlocal-fixed-cpc/`;
    return this.put(url, { ...commission, ad_type: adType });
  }

  getBdspAgencyAdvCommission(id, params: any) {
    let url = this.buildUrl(`${this.resource_url}${id}/bdsp-agc-comm/`, "", params);
    return this.get(url);
  }

  setBdspAgencyAdvCommission(id, commission: bdspCommission, params: any) {
    let url = this.buildUrl(`${this.resource_url}${id}/bdsp-agc-comm/`, "", params);
    return this.put(url, commission);
  }
}

@Injectable({ providedIn: "root" })
export class AgencyHelperService {
  constructor() { }

  prepareAgency(agency: any, isCreate: boolean = false): any {
    if (!agency.apnx_enabled) {
      agency.apnx_commission = new Commission();
    }

    delete agency.config?.override_msa_check;

    if (!agency.adsp_enabled) {
      agency.adsp_regions = null;
      agency.adsp_target_countries = null;
    }

    if (!agency.tdsp_enabled) {
      agency.tdsp_details = null;
    }
    else if (agency.tdsp_enabled && isCreate){
      agency.tdsp_details.pricing_model = null;
    }
    if (!agency.tdsp_hyperlocal_enabled) {
      agency.hyperlocal_details = null;
    }
    else if (agency.tdsp_hyperlocal_enabled && isCreate){
      agency.hyperlocal_details.pricing_model = null;
    }

    if (
      (agency.adsp_enabled || agency.bdsp_enabled || agency.tdsp_enabled || agency.tdsp_hyperlocal_enabled) &&
      !agency.apnx_enabled
    ) {
      agency.apnx_commission.contract_commission = 0;
    }
     if (agency.vizibl_category_ids && !Array.isArray(agency.vizibl_category_ids)) {
    agency.vizibl_category_ids = [agency.vizibl_category_ids];
  }
    return agency;
  }
}

@Injectable({ providedIn: "root" })
export class AgnAdvHelperService {
  targetingEU: boolean = false;
  isAdvPayer: boolean = false;

  constructor() { }

 prepareTDSPAgnAdv(agencyAdvertiser: any, legacy_user: boolean = false, isHyperLocal: boolean = false): any {

  agencyAdvertiser.adsp_details = null;
  agencyAdvertiser.bdsp_category = null;

  this.targetingEU = agencyAdvertiser.tdsp_details.targetingEU;
  this.isAdvPayer = agencyAdvertiser.tdsp_details.isAdvPayer;

  delete agencyAdvertiser.tdsp_details.targetingEU;
  delete agencyAdvertiser.tdsp_details.isAdvPayer;

  if (!this.targetingEU) {
    agencyAdvertiser.tdsp_details.eu_advertiser_name = null;
    agencyAdvertiser.tdsp_details.payer_name = null;
  }

  if (this.isAdvPayer) {
    agencyAdvertiser.tdsp_details.payer_name = null;
  }

  if (agencyAdvertiser.vizibl_category_ids) {
    agencyAdvertiser.vizibl_category_ids = Array.isArray(agencyAdvertiser.vizibl_category_ids)
      ? agencyAdvertiser.vizibl_category_ids
      : [Number(agencyAdvertiser.vizibl_category_ids)];
  }

  if (isHyperLocal) {
    agencyAdvertiser.tdsp_enabled = false;
    agencyAdvertiser.hyperlocal_details = agencyAdvertiser.tdsp_details;
    agencyAdvertiser.tdsp_details = null;
    agencyAdvertiser['tdsp_hyperlocal_enabled'] = true;
  }
  else{
    agencyAdvertiser['tdsp_hyperlocal_enabled'] = false;
    agencyAdvertiser.hyperlocal_details = null; 
    agencyAdvertiser.tdsp_enabled  = true;
  }

  if(legacy_user) {
    delete agencyAdvertiser.vizibl_category_ids;
    delete agencyAdvertiser.vizibl_subcategory_id;
  }

  delete agencyAdvertiser.vizibl_category_id;

  return agencyAdvertiser;
}

  restoreTdsp(agencyAdvertiser: any) {
    if (!agencyAdvertiser.tdsp_details) {
      agencyAdvertiser.tdsp_details = agencyAdvertiser.hyperlocal_details;
      agencyAdvertiser.hyperlocal_details = null;
    }
    if (agencyAdvertiser?.tdsp_details) {
      agencyAdvertiser.tdsp_details.targetingEU = this.targetingEU;
      agencyAdvertiser.tdsp_details.isAdvPayer = this.isAdvPayer;
    }
  }
}
